const DataSecurity = () => {
  return (
    <div className="container mt-5">
      <h1>Data Consistency Checker</h1>
      <p className="alert alert-warning">
        <strong>Notice:</strong> This page is currently under construction. We are developing a comprehensive data consistency validation system.
      </p>
      
      <h2>What is Data Consistency Checking?</h2>
      <p>
        Our Data Consistency Checker is designed to validate and ensure the reliability of statistical data across multiple dimensions:
      </p>
      
      <h2>Validation Features</h2>
      <ul>
        <li><strong>Year-over-Year Analysis:</strong> Compare data trends and identify inconsistencies between consecutive years to detect anomalies or data entry errors.</li>
        <li><strong>Country-by-Country Validation:</strong> Cross-reference statistical indicators across different countries to ensure data integrity and consistency in reporting standards.</li>
        <li><strong>Unit Type Verification:</strong> Validate that indicators are measured using consistent units and methodologies across all datasets.</li>
        <li><strong>Data Quality Assessment:</strong> Identify missing values, outliers, and potential data quality issues that may affect analysis accuracy.</li>
        <li><strong>Automated Reports:</strong> Generate comprehensive reports highlighting data inconsistencies and providing recommendations for data correction.</li>
      </ul>
      
      <h2>Key Benefits</h2>
      <ul>
        <li>Ensure data reliability for accurate statistical analysis</li>
        <li>Maintain consistency across different time periods and geographical regions</li>
        <li>Standardize unit measurements for comparable results</li>
        <li>Improve overall data quality and research credibility</li>
        <li>Support evidence-based decision making with validated datasets</li>
      </ul>
      
      <h2>Coming Soon</h2>
      <p>
        We are actively developing this tool to provide you with robust data validation capabilities. The system will include:
      </p>
      <ul>
        <li>Interactive dashboard for data consistency monitoring</li>
        <li>Customizable validation rules and thresholds</li>
        <li>Export functionality for validation reports</li>
        <li>Real-time alerts for data inconsistencies</li>
      </ul>
      
      <h2>Contact Us</h2>
      <p>
        For questions about our data consistency checking features or to report data quality issues, please contact us at <a href="mailto:support@sesric.org">support@sesric.org</a>.
      </p>
    </div>
  );
};

export default DataSecurity;